<template>
  <div class="spec-container">

    <h2>{{ title }}</h2>

    <div class="specs-grid">
      <div v-for="(item, index) in specs" :key="index" class="spec-item">
        <strong>{{ item.component }}</strong>
        <p>{{ item.spec }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      specs: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        default: "PC Build Specs"
      }
    }
  };
</script>
<style scoped>
  .specs-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    background: rgba(255, 255, 255, 0.1);
    padding: 20px;
    border-radius: 10px;
  }

  .spec-item {
    background: #222;
    padding: 15px;
    border-radius: 8px;
    text-align: center;
    color: white;
  }

    .spec-item strong {
      display: block;
      font-size: 18px;
      margin-bottom: 5px;
    }
  @media (max-width: 1024px) {
    .specs-grid {
      grid-template-columns: initial;
    }
  }
</style>
